// tslint:disable: max-line-length
import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { DwSectionBaseComponent, DwComponent, DwExpressionService, DwComponentType, DwPageBaseComponent, DwComponentSectionConfigPreference, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwMetaDataService, DwMetaDataServiceToken, DwMdAttribute, DwQueryMdAttribute, DwContextMetaData } from '@devwareapps/devware-cap';
import { DwFormControlLookupComponent } from '@devwareapps/devware-cap';
import { PowerBiConfig } from '../models/power-bi-config.model';
import { PowerBiConfigComponent } from './power-bi-config/power-bi-config.component';
import * as pbi from 'powerbi-client';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/environments/environment';
import { Report } from 'powerbi-client';
import { finalize, flatMap, map, throttleTime } from 'rxjs/operators';
import { any } from 'underscore';
import { Observable, of, Subject } from 'rxjs';
import { colCount } from 'prosemirror-tables';

//TODO: Make component collapsible
@DwComponent({
  name: 'PowerBi',
  isGlobal: true,
  componentType: DwComponentType.formSection,
  configComponent : PowerBiConfigComponent
})
@Component({
  selector: 'app-power-bi',
  templateUrl: './power-bi.component.html',
  styleUrls: ['./power-bi.component.scss']
})
export class PowerBiComponent extends DwSectionBaseComponent<DwComponentSectionConfigPreference<PowerBiConfig>> {
  pageConfig: PowerBiConfig;

  reportId: string;
  workspaceId: string;
  filters: string[];
  filtersContext: {dwQueryMdAttribute: DwQueryMdAttribute, dwContextMetaData: DwContextMetaData}[];
  waitSubject = new Subject();
  report : Report = null;
  basicFilter: any[] = [];
  config: any = null;
  tables: string[] = [];
  reportReloadQueue: number = 0;

  public screenHeight:number;
  @ViewChild('reportContainer') reportContainer: ElementRef;

  powerBiConfig: PowerBiConfig;
  constructor( dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    dwExpressionService: DwExpressionService,
    private http: HttpClient){
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
  }

  ngOnInit() {
    this.powerBiConfig = this.sectionConfig.config;
    this.reportId = this.powerBiConfig.reportId;
    this.workspaceId = this.powerBiConfig.workspaceId;
    this.filters = this.powerBiConfig.filters;
    this.filtersContext = this.powerBiConfig.filtersContext;

    var obsToken = this.getToken(this.reportId, this.workspaceId);
    if (this.powerBiConfig.tableNames != "" && this.powerBiConfig.tableNames != null){
      this.tables = this.powerBiConfig.tableNames.split(';');
    }
    obsToken.subscribe((y: any) => this.showReport(y.token, this.reportId));
    super.ngOnInit();
  }

  showReport(accessToken, reportID) {
    const reportContainer = this.reportContainer.nativeElement;
    const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);

    this.createConfig(reportID, accessToken);
    this.report = <Report>(powerbi.embed(reportContainer, this.config));

    this.waitSubject.pipe(throttleTime(50)).subscribe( () => {
        this.setFilters(reportID, accessToken);
        this.report.reload();
    })
    if(this.filters != null){
      this.filters.forEach(filter => {
      this.getAttrCtrl(filter).statusChanges.subscribe(x => {
        this.waitSubject.next(null);
      })
    })

    this.filtersContext.forEach(filterContext => {
      this.context[filterContext.dwContextMetaData.contextDef.contextName].subscribe(context => {
        this.waitSubject.next(null);
      })
    })
  }


}
  getToken(reportId, workspaceId){
    const url: string = ConfigService.config.apiRoot + "/powerbi/token?reportId=";
    return this.http.get(url + reportId + '&WorkSpaceId=' + workspaceId);
  }

  setFilters(reportID, accessToken){
    this.filters.forEach(x => this.trimBasicFilters(this.getAttributeValue(x), x));
    this.createConfig(reportID, accessToken);
    this.filtersContext.forEach(x =>{
      var AttributeName = x.dwQueryMdAttribute.AttributeName;
      let filterValueObservable = this.getContextValue(x.dwContextMetaData.contextDef.contextName, AttributeName)
      filterValueObservable.subscribe(value => this.trimBasicFilters(value, x.dwQueryMdAttribute.AttributeName, reportID, accessToken));
    });
  }

  createConfig(reportID, accessToken){
    var isDev = ConfigService.config.production
    let config: any = { type: 'report', id: reportID,
                        embedUrl: 'https://app.powerbi.com/reportEmbed',
                        tokenType: pbi.models.TokenType.Embed,
                        accessToken: accessToken,
                        settings: { filterPaneEnabled: !isDev,
                                    background: pbi.models.BackgroundType.Transparent },
                        filters: this.basicFilter
                      };
    this.config = config;
    if (this.report != null){
      this.report.config = config;
      this.reloadReport();
    }
  }

  async reloadReport(){
    this.reportReloadQueue++;
    let reportReloadQueueNumber = this.reportReloadQueue;
    await this.delay(1200);
    if (reportReloadQueueNumber == this.reportReloadQueue){
      const cfg: any  = this.report.config;
      //cfg.filters.forEach(f => console.log(`Filter: ${f.target.table}.${f.target.column}=${f.values[0]}`));
      this.report.reload();
      console.log('Reloaded Report was most recent reload attempt.')
    }
    else{
      console.log('Did not reload report due to being not newest request')
    }

  }

  trimBasicFilters(value: any, col: string, reportID: any = null, accessToken: string = null){
    const filterValue = Number(value);
    if (filterValue != null){
      this.basicFilter.forEach(item => {  
        let target : any = item.target;
        if (target.column == col){
          var index = this.basicFilter.findIndex(y => y.target.column == col);
          while (index != -1){
            this.basicFilter.splice(index ,1)
            index = this.basicFilter.findIndex(y => y.target.column == col);
          }
        }
      });
      this.tables.forEach(table => {
        if (this.isMissing(table, col, filterValue)) {
          this.addBasicFilter(table, col, filterValue);
        }
      });
      if (reportID && accessToken) {
        this.createConfig(reportID, accessToken);
      }
    }
  }
  getAttributeValue(attrName: string) {
    const control = this.getOrCreateFormControl(attrName);
    if (!control) {
      console.warn(`Attribute ${attrName} as not found in the form group!`);
      return `${attrName} not found`;
    }
    return control.value;
  }
  getAttrCtrl(attrName: string) {
    const control = this.getOrCreateFormControl(attrName);
    if (!control) 
      console.warn(`Attribute ${attrName} as not found in the form group!`);
    return control;
  }
  getContextValue(contextName: string, contextField: string) : Observable<any> {
    if (this.context[contextName] != null){
      return this.context[contextName]
                .pipe(map(x => { if (x != null){
                                    const value : number = x[contextField];
                                    return value;
                                  }
                                }))
    }
    else
      return of(null)
  }
  isMissing(table: string, col: string, filterValue: number){
    const missing = this.basicFilter.filter(e => e.target.table == table).filter(e => e.target.column == col).filter(e => e.values[0] == filterValue).length == 0;
    //console.log(`${table}.${col}=${filterValue} found ${!missing}`);
    return missing;
  }
  addBasicFilter(table: string, col: string, filterValue: number){
    this.basicFilter.push({   $schema: "http://powerbi.com/product/schema#basic",
                              target: { table: table, column: col },
                              operator: "In",
                              values: [filterValue],
                              filterType: 1 /* pbi.models.FilterType.BasicFilter */ });
    //console.log(`Basic Filter Length= ${this.basicFilter.length}`);
  }
  delay(ms: number) { return new Promise( resolve => setTimeout(resolve, ms) ); }
}
